import React from 'react';
import { IconButton, PrimaryButton, DefaultButton } from '@fluentui/react';
import { Text } from '@fluentui/react-components';
import { usePageContext } from '../../hooks/PageContext';

/* Кнопка "Назад" — универсальная */
export const BackButton: React.FC<{ onClick: () => void; title?: string; style?: React.CSSProperties }> = ({
  onClick,
  title = 'Назад к списку',
  style,
}) => (
  <IconButton iconProps={{ iconName: 'Back' }} title={title} onClick={onClick} style={style} />
);

/* Кнопка "Новая статья" — видна только админам */
export const NewArticleButton: React.FC = () => {
  const { actions } = usePageContext();
  const { isAdmin, setForm, setCurrentNote, setIsCreating, setMode } = actions;

  if (!isAdmin) return null;

  return (
    <PrimaryButton
      iconProps={{ iconName: 'Add' }}
      text="Новая статья"
      onClick={() => {
        setForm({ title: '', content: '', image: '', previewImage: '', tags: '', attachments: [] });
        setCurrentNote(null);
        setIsCreating(true);
        setMode('edit');
      }}
      style={{ marginBottom: '20px' }}
    />
  );
};

/* Панель "Выбрано N + Удалить" — видна только админам при выборе */
export const SelectedNotesBar: React.FC = () => {
  const { actions } = usePageContext();
  const { isAdmin, selectedNotes, confirmAndDeleteSelected } = actions;

  if (!isAdmin || selectedNotes.size === 0) return null;

  return (
    <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Text weight="semibold">Выбрано: {selectedNotes.size}</Text>
      <DefaultButton
        iconProps={{ iconName: 'Delete' }}
        text="Удалить"
        onClick={confirmAndDeleteSelected}
      />
    </div>
  );
};

